export const PLAYLIST_OBJECT = "PLAYLIST_OBJECT";
export const RELOAD_PLAYLIST_FETCH = "RELOAD_PLAYLIST_FETCH";

// export const IS_PLAY_BAR_DISPLAYED = "IS_PLAY_BAR_DISPLAYED";
// export const SET_POSITION_IN_HISTORY = "SET_POSITION_IN_HISTORY";
